module.exports = __webpack_public_path__ + "static/media/home_water.8ef87d80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_water.svg
// module id = 517
// module chunks = 0